import redux, { Dispatch, Reducer } from 'redux'

export interface Notification {
  index?: number;
  color?: string;
  duration?: number;
  message: string;
}

export interface NotificationState {
  list: Notification[]
  index: number
}

type ActionTypes = 'NOTIFICATION_ADD' | 'NOTIFICATION_REMOVE';
type Action = redux.Action<ActionTypes> & redux.AnyAction

const initialState: NotificationState = {
  list: [],
  index: 0,
}

export const actionTypes: {[key: string]: ActionTypes} = {
  ADD: 'NOTIFICATION_ADD',
  REMOVE: 'NOTIFICATION_REMOVE'
}

export const notification: Reducer<NotificationState, Action> = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.ADD:
      return Object.assign({}, state, {
        list: [
          ...state.list,
          {
            ...action.notification,
            index: state.index + 1,
          }
        ],
        index: state.index + 1,
      })

    case actionTypes.REMOVE:
      return Object.assign({}, state, {
        list: state.list.filter(n => n.index !== action.notification.index),
      })
  }

  return state
}

export type removeNotificationType = (notfication: Notification) => any
export const removeNotification = (notification: Notification) => async (dispatch: Dispatch<Action>) => {
  await dispatch({
    type: actionTypes.REMOVE,
    notification
  })
}

export type addNotificationType = (notfication: Notification) => any
export const addNotification = (notification: Notification) => async (dispatch: Dispatch<Action>) => {
  await dispatch({
    type: actionTypes.ADD,
    notification
  })
}

export const notificationInitialize = () => async (dispatch: Dispatch<Action>) => {
}
